<template>
    <div class="box">
        <el-form label-width="auto">

            <el-form-item label="标题">
                <el-input v-model="myObj.photo_classify_line_tiny_params.title" placeholder="请输入"></el-input>
            </el-form-item>

            <el-form-item label="间距">
                <el-input-number v-model="myObj.photo_classify_line_tiny_params.margin" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="展示个数">
                <el-input-number v-model="myObj.component_source.params.total" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="图片宽">
                <el-input-number v-model="myObj.photo_classify_line_tiny_params.icon_width" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="图片高">
                <el-input-number v-model="myObj.photo_classify_line_tiny_params.icon_height" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="图片圆角">
                <el-input-number v-model="myObj.photo_classify_line_tiny_params.corner_radius" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="元素间距">
                <el-input-number v-model="myObj.photo_classify_line_tiny_params.between_space" :min="0"></el-input-number>
            </el-form-item>

            <ComponentSource :component_source="obj.component_source" />

        </el-form>
    </div>
</template>

<script>

import ComponentSource from '../../ComponentSource/ComponentSource.vue';

export default {
    name: "PhotoClassifyLineTinyProp",
    components: {
        ComponentSource
    },
    props: ['obj'],
    data() {
        return {
            myObj: this.obj,
      
        }
    },
    mounted() {
    },
    methods: {

    }
}
</script>

<style scoped lang="less">
.box {
    padding: 15px;
}
</style>